import { createAsyncThunk } from '@reduxjs/toolkit';
import { AugmentedPhoneExtension } from '../../shared/services/contactsService';
import appConfig from '../helpers/appConfig';
import { ThunkAPI } from '../store/types';

const subscribePhone = (phone: AugmentedPhoneExtension, domain: string) => {
  appConfig.extension?.subscribeCustom(phone.username, domain);
};

export const subscribePhones = createAsyncThunk<void, void, ThunkAPI>(
  'contacts/subscribePhones',
  (_, thunkAPI) => {
    const {
      contacts: { phones },
      client,
    } = thunkAPI.getState();

    if (client.extension?.sip) {
      const { domain } = client.extension.sip;

      phones
        .filter((phone) => !phone.subscribed)
        .forEach((phone) => {
          subscribePhone(phone, domain);
        });
    } else {
      /**
       * If we've not got the extension's sip credentials yet
       * then wait for a second and try again
       */
      setTimeout(() => {
        thunkAPI.dispatch(subscribePhones());
      }, 1000);
    }
  },
);
